/* eslint-disable */
import {
    ADD_REQUISITION, FILTER_REQUISITION, MANAGE_REQUISITION, GET_ALL_REQUISITION, GET_REQUISITION_BY_ID, GET_ALL_REQUISITION_DROPDOWN, UPDATE_REQUISITION,
    GET_ALL_REQUISITION_POST_DROPDOWN, GET_ALL_REQUISITION_DEPARTMENT_DROPDOWN, GET_ALL_REQUISITION_SPECIALISATION_DROPDOWN, GET_ALL_REQUISITION_INSTITUTION_DROPDOWN,
    GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN, GETADVERTISEMENT, GET_APPLICATION_COUNT, GET_ALL_ACTIVE_AND_PAST_ADVERTISEMENT, LOOKUP_OPTION
} from "../../common/constants/endpoints";
import API from "../../helpers/API";
import {
    SET_ALL_REQUISITION, SET_REQUISITION_DATA, SET_ALL_REQUISITION_DROPDOWN, SET_ALL_REQUISITION_PAGE_NO_COUNTER, SET_ALL_REQUISITION_POST_DROPDOWN, SET_ALL_REQUISITION_TYPE_DROPDOWN, SET_ALL_REQUISITION_DEPARTMENT_DROPDOWN, SET_ALL_REQUISITION_SPECIALISATION_DROPDOWN,
    SET_ALL_REQUISITION_INSTITUTION_DROPDOWN, SET_ALL_REQUISITION_GROUP_DROPDOWN, SET_ALL_REQUISITION_CLASS_DROPDOWN, SET_ALL_REQUISITION_STATUS_DROPDOWN, SET_ALL_ADVERTISEMENT_DROPDOWN, SET_ALL_ADMINISTRATIVE_DEPARTMENT_DROPDOWN,SET_APPLICATION_COUNT, SET_STAGE_STATUS_DESK_DROPDOWN
} from '../../common/constants/ActionTypes';
import { toastr } from 'react-redux-toastr';

export const addRequisition = (newRequisitionDetails, setAddRequisitionData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_REQUISITION, newRequisitionDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setAddRequisitionData({ "Mode": false });

            dispatch(getAllRequisitionListPagination(0, 10));

            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getAllRequisitionListPagination = (pageNumber, rowPerPage, postId = '', deptId = '', grpid = '', rqdate = '', typeid = '', statusid = '', classid = '', advid="") => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if ((postId != '' && postId != null && postId != undefined) || (deptId != '' && deptId != null && deptId != undefined) || (grpid != '' && grpid != null && grpid != undefined) || (rqdate != '' && rqdate != null && rqdate != undefined) || (typeid != '' && typeid != null && typeid != undefined) || (statusid != '' && statusid != null && statusid != undefined) || (classid != '' && classid != null && classid != undefined)|| (advid != '' && advid != null && advid != undefined)) {
                response = await API.get(FILTER_REQUISITION + `/${pageNumber}` + `/${rowPerPage}` + `?postid=${postId}` + `&deptid=${deptId}` + `&grpid=${grpid}` + `&typeid=${typeid}` + `&statusid=${statusid}` + `&classid=${classid}` + `&advid=${advid}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_REQUISITION + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }



            if (response) {

                dispatch({
                    type: SET_ALL_REQUISITION,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_REQUISITION_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }

        } catch (error) {
            dispatch({
                type: SET_ALL_REQUISITION,
                payload: [],
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const updateRequest = (requestData, setAddRequisitionData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(UPDATE_REQUISITION, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setAddRequisitionData({ "Mode": false });
            dispatch(getAllRequisitionListPagination(0, 10));
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const deleteRequisitionRequest = (requestData, setShowDeleteModal, rowPerPage, listCurrentPage) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_REQUISITION, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }
            setShowDeleteModal(false);
            dispatch(getAllRequisitionListPagination(showPage, rowPerPage));
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const getRequisition = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_REQUISITION_BY_ID + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response != null) {
                dispatch({
                    type: SET_REQUISITION_DATA,
                    payload: response.data,
                });
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const manageRequisitionRequest = (requestData, rowPerPage, listCurrentPage) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_REQUISITION, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }
            dispatch(getAllRequisitionListPagination(showPage, rowPerPage));
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const getRequisitionDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_REQUISITION_DROPDOWN, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQUISITION_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const resetRequisition = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_REQUISITION_DATA,
            payload: {},
        });
    }
}
export const resetRequisitionList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_REQUISITION,
            payload: {},
        });
    }
}

export const getRequisitionPostDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_REQUISITION_POST_DROPDOWN, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQUISITION_POST_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getRequisitionDepartmentDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_REQUISITION_DEPARTMENT_DROPDOWN, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQUISITION_DEPARTMENT_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getRequisitionSpecialisationDropDown = (id='') => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if(id!=='' && id!==null && id!==undefined){
                response = await API.get(`${GET_ALL_REQUISITION_SPECIALISATION_DROPDOWN}?reqinstid=${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                dispatch({
                    type: SET_ALL_REQUISITION_SPECIALISATION_DROPDOWN,
                    payload: response.data,
                });
            }else{
                response = await API.get(`${GET_ALL_REQUISITION_SPECIALISATION_DROPDOWN}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                dispatch({
                    type: SET_ALL_REQUISITION_SPECIALISATION_DROPDOWN,
                    payload: response.data,
                });
                // dispatch({
                //     type: SET_ALL_REQUISITION_SPECIALISATION_DROPDOWN,
                //     payload: [],
                // });
            }

        } catch (error) {
            dispatch({
                type: SET_ALL_REQUISITION_SPECIALISATION_DROPDOWN,
                payload: [],
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getRequisitionInstitutionDropDown = (value) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            // response = await API.get(GET_ALL_REQUISITION_INSTITUTION_DROPDOWN, {
            if(value!=='' && value!==null && value!==undefined){
                response = await API.get(`${GET_ALL_REQUISITION_INSTITUTION_DROPDOWN}/${value}`, {

                    headers: { Authorization: `Bearer ${token}` },
                });
                dispatch({
                    type: SET_ALL_REQUISITION_INSTITUTION_DROPDOWN,
                    payload: response.data,
                });
            }else{
                // response = await API.get(`${GET_ALL_REQUISITION_INSTITUTION_DROPDOWN}`, {

                //     headers: { Authorization: `Bearer ${token}` },
                // });
                dispatch({
                    type: SET_ALL_REQUISITION_INSTITUTION_DROPDOWN,
                    payload: [],
                });
            }
            
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            dispatch({
                type: SET_ALL_REQUISITION_INSTITUTION_DROPDOWN,
                payload: [],
            });
            return;
            
        }
    };
}
export const getRequisitionTypeDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN + `?module=exam_creation&type=exam_type`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQUISITION_TYPE_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getRequisitionGroupDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN + `?module=requisition&type=group`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQUISITION_GROUP_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getRequisitionClassDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN + `?module=requisition&type=group_type`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQUISITION_CLASS_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getRequisitionStatusDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN + `?module=requisition&type=status`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQUISITION_STATUS_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
// export const getAdministrativeDepartmentsDropDown = () => {
//     return async function (dispatch) {
//         const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
//         let token = session.jwtResponse && session.jwtResponse.token;
//         let response;
//         try {
//             response = await API.get(GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN + `?module=requisition&type=administrative_department`, {
//                 headers: { Authorization: `Bearer ${token}` },
//             });
//             dispatch({
//                 type: SET_ALL_ADMINISTRATIVE_DEPARTMENT_DROPDOWN,
//                 payload: response.data,
//             });
//         } catch (error) {
//             let errorMessage = (error.response && error.response.data) ?
//                 error.response.data.message : error.message
//             toastr.error(errorMessage);
//             return;
//         }
//     };
// };
export const getAllAdvertisementDropDown = (year) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_ACTIVE_AND_PAST_ADVERTISEMENT + `?year=${year}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_ADVERTISEMENT_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getApplicationCountByAdvt = (advid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_APPLICATION_COUNT + `?advid=${advid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_APPLICATION_COUNT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getStageStatusDeskDropdownData = () => {
    return async (dispatch) => {

        let response = await API.get(LOOKUP_OPTION, {
            params: { module: "requisition" }
        });


        dispatch({
            payload: (response && response.data) ? response.data : [],
            type: SET_STAGE_STATUS_DESK_DROPDOWN
        });



    }
};